import React from "react";
import styled from "styled-components";
import {Link} from "react-router-dom";
import ArrowTo from "../assets/icons/to_right.png";
import MediaTo from "../assets/icons/media.png";

export default function ShowMore({type, url, id}) {
   switch (type) {
      case 1:
         return (
            <ToLink to={`/cursos_esenciales/${id}`}>
               <Text>Ver más</Text>
               <img src={ArrowTo} alt=">" width="20px" />
            </ToLink>
         );
      case 2:
         return (
            <ToLink to={`/cursos_esenciales/${id}`}>
               <Text>Ver más</Text>
               <img src={ArrowTo} alt=">" width="20px" />
            </ToLink>
         );
      case 3:
         return (
            <ToLink to={`/programa_emblem/`}>
               <Text>Ver más</Text>
               <img src={ArrowTo} alt=">" width="20px" />
            </ToLink>
         );
      case 5:
         return (
            <ToLink to={`/masterclass/${id}`}>
               <Text>Ver más</Text>
               <img src={ArrowTo} alt=">" width="20px" />
            </ToLink>
         );
      default:
         return null;
   }
   /* if (type === "video") {
      return (
         <ToLink to={url || "/videos/01"}>
            <Text>Ver video</Text>
            <img src={MediaTo} alt=">" width="20px" />
         </ToLink>
      );
   }
   return (
      <ToLink to={url || "/cursos/info"}>
         <Text>Ver más</Text>
         <img src={ArrowTo} alt=">" width="20px" />
      </ToLink>
   ); */
}

const ToLink = styled(Link)`
   text-decoration: none;
   padding: 0.3em 0;
   margin: 1em 0;
   display: flex;
   align-items: center;

   & img {
      width: 25px;
      height: 25px;
      margin-top: 3px;
      margin-left: 10px;
   }
   @media screen and (max-width: 1600px) {
      padding: 0.2em 0;
      margin: 0.5em 0;

      & img {
         width: 20px;
         height: 20px;
         margin-left: 10px;
      }
   }

   @media screen and (max-width: 1400px) {
      & img {
         width: 17px;
         height: 17px;
         margin-left: 10px;
      }
   }

   @media screen and (max-width: 1400px) {
      & img {
         width: 14px;
         height: 14px;
         margin-left: 10px;
      }
   }
`;

const Text = styled.p`
   color: #c4b687;
   font-size: 1.5em;
   font-weight: 500;
   margin: 0;

   @media screen and (max-width: 1600px) {
      font-size: 1.2em;
   }

   @media screen and (max-width: 1400px) {
      font-size: 1em;
   }

   @media screen and (max-width: 800px) {
      font-size: 0.8em;
   }
`;
